// AIDEV-NOTE: PLAT-17342 — Shared A-Z-by-first-name sort for Present Mode student lists
// (Notify Students modal + Students panel). `sensitivity: 'base'` makes it case-insensitive;
// last-name fallback handles students who share a first name.
const collator = new Intl.Collator('en', { sensitivity: 'base' });

interface StudentLike {
  first_name: string;
  last_name: string;
}

const sortStudentsByFirstName = <T extends StudentLike>(students: T[]): T[] => (
  [...students].sort((a, b) => (
    collator.compare(a.first_name, b.first_name) || collator.compare(a.last_name, b.last_name)
  ))
);

export default sortStudentsByFirstName;
